/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Due_Date_AriaInputs */



/**
* | output |
* | --- |
* | "Edit due date" |
*
* @param {Explorer_Info_Due_Date_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_due_date_aria = /** @type {((inputs?: Explorer_Info_Due_Date_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Due_Date_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Edit due date")
	if (locale === "de") return /** @type {LocalizedString} */ ("Edit due date")
	if (locale === "it") return /** @type {LocalizedString} */ ("Edit due date")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Edit due date")
	if (locale === "es") return /** @type {LocalizedString} */ ("Edit due date")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Edit due date")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Edit due date")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Edit due date")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Edit due date")
	return /** @type {LocalizedString} */ ("Edit due date")
});